import Icon from '@/shared/assets/icons/orderIcon.svg?react'
import { BaseButton } from '@/shared/components'
import { DisputModel, DisputStatus } from '../model/types'

type Props = {
  disput: DisputModel
  openDialog: (id: string) => void
}

export const renderActionButton = ({ disput, openDialog }: Props) => {
  switch (disput.status) {
    case DisputStatus.Created:
    case DisputStatus.Reopened:
      return (
        <BaseButton
          onClick={() => openDialog(disput.id)}
          radius="lg"
          icon={<Icon />}
          className="whitespace-nowrap w-full md:w-[200px]"
        >
          Взять в работу
        </BaseButton>
      )
    case DisputStatus.InProgress:
      return (
        <BaseButton
          onClick={() => openDialog(disput.id)}
          radius="lg"
          icon={<Icon />}
          className="whitespace-nowrap w-full md:w-[200px]"
          variant="outlined"
        >
          Перейти к спору
        </BaseButton>
      )
    default:
      return null
  }
}
